
export const buildSelector = (select) => (styles) => ({
  [select] : styles
});

export const mediaQuery = (query) => buildSelector(`@media(${query})`);
export const supports = (feature) => buildSelector(`@supports(${feature})`);
export const selectOr = (...selectors) =>
  (styles) =>
    selectors.reduce((result, arg) => ({ ...result, ...arg(styles) }), {});

export const selectNest = (...selectors) =>
  (styles) =>
    selectors.reduceRight((result, selector) => selector(result), styles);



// WEBPACK FOOTER //
// ./src/util/style-queries.js